import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "../../services/apiService";

export const fetchLaundryOngoing = createAsyncThunk(
  "laundryOngoing/fetchLaundryOngoing",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apiService.get("/ongoing", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const ongoingLaundryOrderSlice = createSlice({
  name: "laundryOngoing",
  initialState: {
    laundryOngoings: [],
    status: "idle",
    error: null,
    singleLaundryOngoing: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLaundryOngoing.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchLaundryOngoing.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.laundryOngoings = action.payload.data;
      })
      .addCase(fetchLaundryOngoing.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default ongoingLaundryOrderSlice.reducer;
